import requestCommon from "@/components/web-interface/requestCommon";
const state = {
    analyticsData: null,
    analyticsDataByUserId: null,
};
const actions = {
    getAnalyticsData(context, data) {
        return requestCommon.postInfo(
            "/analytics/positions",
            null,
            data.userIds,
            context,
            "getAnalyticsDataSuccessHandler",
            "getAnalyticsDataErrorHandler"
        );
    },
    getAnalyticsDataById(context, data) {
        return requestCommon.getInfo(
            "/analytics/positions/" + data.userId+ "?refresh=" + data.refresh,
            null,
            null,
            context,
            "getAnalyticsDataByUserIdSuccessHandler",
            "getAnalyticsDataByUserIdErrorHandler"
        );
    },
}
const mutations = {
    getAnalyticsDataSuccessHandler(state, data) {
        state.analyticsData = data.server.data;
    },
    getAnalyticsDataErrorHandler(context, error,) {
        console.log(error);
    },
    getAnalyticsDataByUserIdSuccessHandler(state, data) {
        state.analyticsDataByUserId = data.server.data;
    },
    getAnalyticsDataByUserIdErrorHandler(context, error,) {
        console.log(error);
    },
};
const getters = {};
export const analyticsDashboard = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}